import { FormattedMessage } from 'react-intl';
import { Button, Form, Modal, ModalProps, Space } from 'antd';
import { WorkOrderObservation } from '@/core/domain/workorder/WorkOrdersObservations/WorkOrdersObservations.types';
import WorkOrderObservationForm, {
  WorkOrderObservationData,
} from '../ObservationForm';
import { useEffect } from 'react';
import {
  useCheckListObservationCreate,
  useCheckListObservationUpdate,
} from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.hooks';
import { ChecklistObservationRequest } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.types';
import { useWorkorderChecklistContext } from '../../../WorkorderChecklist/WorkorderChecklistProvider';

interface Props extends ModalProps {
  observation?: WorkOrderObservation;
  onCancel: () => void;
}

function WorkOrderChecklistObservationModal(props: Props) {
  const [form] = Form.useForm<WorkOrderObservationData>();
  const { workorderComplementId, diagnosticId } =
    useWorkorderChecklistContext();

  const createMutation = useCheckListObservationCreate();
  const updateMutation = useCheckListObservationUpdate();

  useEffect(() => {
    if (props.observation) {
      form.setFieldsValue(props.observation);
    }
  }, [props.observation]);

  const handleSubmit = async () => {
    const values = await form.validateFields();

    const observationData: ChecklistObservationRequest = {
      ...values,
      workOrderComplementId: workorderComplementId,
      diagnosticId: diagnosticId,
    };

    if (props.observation) {
      const obj: ChecklistObservationRequest = {
        ...observationData,
        observationId: props.observation.id,
      };

      await updateMutation.mutateAsync(obj);
    } else {
      await createMutation.mutateAsync(observationData);
    }

    handleCancel();
  };

  const handleCancel = () => {
    form.resetFields();
    props.onCancel();
  };

  return (
    <Modal
      {...props}
      title="Observação"
      footer={
        <Space>
          <Button onClick={handleCancel}>
            <FormattedMessage id="commons.form.button.close" />
          </Button>

          <Button
            type="primary"
            onClick={handleSubmit}
            loading={createMutation.isLoading || updateMutation.isLoading}
          >
            <FormattedMessage id="commons.entity.save" />
          </Button>
        </Space>
      }
      onCancel={handleCancel}
    >
      <WorkOrderObservationForm form={form} editing={!!props.observation} />
    </Modal>
  );
}

export default WorkOrderChecklistObservationModal;
